function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUWolontariat = function SvgUWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    "data-name": "Warstwa 2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.05 151.84c-24.47 0-44.37-19.91-44.37-44.37v-59.6h24.28v59.6c0 11.08 9.02 20.1 20.1 20.1s20.1-9.02 20.1-20.1v-59.6h24.28v59.6c0 24.47-19.91 44.37-44.37 44.37Z",
    "data-name": "Warstwa 1",
    style: {
      fill: "#ff7900"
    }
  }));
};
export default SvgUWolontariat;